module.exports = __webpack_public_path__ + "img/fillter_active_icon.fc9d0862.svg";